import { render, staticRenderFns } from "./GenericPip.vue?vue&type=template&id=050e078f"
import script from "./GenericPip.vue?vue&type=script&lang=ts"
export * from "./GenericPip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports